import { Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { useAppMode } from '../../stores/appStore'
import { APP_PATHS } from './routes'
import { PageLoader } from '../layout/PageLoader'
import {
  Accounts,
  AdminPage,
  CalendarPage,
  Campaigns,
  Compliance,
  ConsumerWorkspace,
  ContactLists,
  Dashboard,
  Knowledge,
  LiveMonitor,
  MemoryVaultPage,
  MyInfo,
  OutboundPerformance,
  Routing,
  SettingsPage,
} from './lazyPages'

export function AppRoutes() {
  const mode = useAppMode()

  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        {mode === 'individual' ? (
          <>
            <Route path="/" element={<ConsumerWorkspace />} />
            <Route path="/tasks" element={<ConsumerWorkspace />} />
            <Route path="/calls" element={<ConsumerWorkspace />} />
            <Route path="/memory/*" element={<ConsumerWorkspace />} />
            <Route path="/calendar" element={<ConsumerWorkspace />} />
            <Route path="/lists" element={<Navigate to="/settings/lists" replace />} />
            <Route path="/briefing" element={<Navigate to={APP_PATHS.briefing} replace />} />
            <Route path="/info" element={<ConsumerWorkspace />} />
            <Route path="/line" element={<ConsumerWorkspace />} />
            <Route path="/my-number" element={<ConsumerWorkspace />} />
            <Route path="/accounts" element={<Navigate to="/memory/accounts" replace />} />
            <Route path="/documents" element={<Navigate to="/memory/documents" replace />} />
            <Route path="/settings" element={<ConsumerWorkspace />} />
            <Route path="/settings/*" element={<ConsumerWorkspace />} />
            <Route path="admin" element={<AdminPage />} />
            <Route path="admin/*" element={<AdminPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </>
        ) : (
          <>
            <Route path="/" element={<Dashboard />} />
            <Route path="/knowledge" element={<Knowledge />} />
            <Route path="/routing" element={<Routing />} />
            <Route path="/monitor" element={<LiveMonitor />} />
            <Route path="/campaigns" element={<Campaigns />} />
            <Route path="/contacts" element={<ContactLists />} />
            <Route path="/outbound-performance" element={<OutboundPerformance />} />
            <Route path="/compliance" element={<Compliance />} />
            <Route path="/accounts" element={<Accounts />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/settings/*" element={<SettingsPage />} />
            <Route path="admin" element={<AdminPage />} />
            <Route path="admin/*" element={<AdminPage />} />
            <Route path="*" element={<Dashboard />} />
          </>
        )}
      </Routes>
    </Suspense>
  )
}
